import { useState } from 'react';
import { useParams } from 'react-router-dom';
import DossierProcedureAttachments from '../../../components/dossier-procedure/DossierProcedureAttachments';
import DossierProcedureDetails from '../../../components/dossier-procedure/DossierProcedureDetails';
import DossierProcedureGoals from '../../../components/dossier-procedure/DossierProcedureGoals';
import DossierProcedureParts from '../../../components/dossier-procedure/DossierProcedureParts';
import DossierProcedureStakeholders from '../../../components/dossier-procedure/DossierProcedureStakeholders';
import { STAKEHOLDER_DOSSIER_PATHS } from '../../../constants/dossier.constants';
import { MODALS } from '../../../constants/modals.constants';
import { useModal } from '../../../hooks/useModal.hook';
import StakeholderAddModal from '../../../modals/StakeholderAddModal';
import StakeholderDetailModal from '../../../modals/StakeholderDetailModal';
import dossierTabsPermissionsService from '../../../services/permissions/dossier.tabs.permissions.service';

const DossierDetailProcedure = ({
  data,
  openedGoals,
  setOpenedGoals,
  openedParts,
  setOpenedParts,
  openedIndicators,
  setOpenedIndicators,
  attachments,
  isLoadingAttachments,
  onDossierRefetch,
  onAttachmentsRefetch,
  onUpdated,
  permissions,
  user
}) => {
  const params = useParams();
  const stakeholderAddModal = useModal(MODALS.STAKEHOLDER_ADD_MODAL);
  const stakeholderDetailModal = useModal(MODALS.STAKEHOLDER_DETAIL_MODAL);
  const procedurePermissions = dossierTabsPermissionsService.toProcedurePermissions(
    data?.procedure ?? {},
    permissions,
    user
  );

  const [stakeholderDetailModalData, setStakeholderDetailModalData] = useState({});

  if (!procedurePermissions?.read) {
    return null;
  }

  const handleUpdated = (value, field) => {
    onUpdated(value, field, 'procedure');
  };

  const handleStakeholderOpenClick = (data) => {
    setStakeholderDetailModalData(data);
    stakeholderDetailModal.onOpen();
  };

  const sharedProps = {
    ...(data?.procedure ?? {}),
    attachments,
    isLoadingAttachments,
    dossierId: params.id,
    onUpdated: handleUpdated,
    onDossierRefetch,
    onAttachmentsRefetch,
    ...procedurePermissions
  };
  return (
    <div className="spo-o-dossier-detail-procedure">
      <DossierProcedureDetails {...sharedProps} />
      <DossierProcedureStakeholders
        {...procedurePermissions}
        involved={data?.procedure?.involved ?? []}
        onStakeholderAdd={stakeholderAddModal.onOpen}
        onStakeholderOpen={handleStakeholderOpenClick}
      />
      <DossierProcedureGoals
        {...sharedProps}
        attachments={attachments}
        openedGoals={openedGoals}
        setOpenedGoals={setOpenedGoals}
        openedIndicators={openedIndicators}
        setOpenedIndicators={setOpenedIndicators}
      />
      <DossierProcedureParts
        {...sharedProps}
        dossierType={data?.type}
        attachments={attachments}
        openedParts={openedParts}
        setOpenedParts={setOpenedParts}
      />
      <DossierProcedureAttachments {...sharedProps} dossierType={data?.type} />
      <StakeholderAddModal
        {...stakeholderAddModal}
        dossierSchools={data?.overview?.school ?? []}
        onUpdated={handleUpdated}
        dossierId={params.id}
        dossierPath={STAKEHOLDER_DOSSIER_PATHS.PROCEDURE}
      />
      {stakeholderDetailModal.isOpen && (
        <StakeholderDetailModal
          {...stakeholderDetailModal}
          {...procedurePermissions}
          data={stakeholderDetailModalData}
          onUpdated={handleUpdated}
          dossierId={params.id}
          dossierPath={STAKEHOLDER_DOSSIER_PATHS.PROCEDURE}
        />
      )}
    </div>
  );
};

export default DossierDetailProcedure;
